//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniRate from "@/components/uni-rate/uni-rate.vue"
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import { getListByCode } from "@/common/js/dictionary.js"
import search from "@/components/search/index.vue"
export default {
  data() {
    return {
      city: {
        name: '地区',
        code: ''
      },
      actions: [],
      isFixed: false,
      form: {
        bodyName: '', // 名称（模糊查询）
        districtCode: '', // 区县code
        cityCode: '',
        provinceCode: '',
        labelCode: '',
        orderByIndex: 10
      },
      end: false,
      count: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        loading: false
      },
      list: [],
      menu: [ // 筛选菜单栏
        // {
        //   title: '城市', // 标题
        //   option: [], // 筛选菜单的数组
        //   isDefault: false // 是否使用默认样式
        // },
        {
          title: '餐厅类型',
          detailList: []
        },
        {
          title: '排序',
          style: "columnar",
          detailList: [{ name: '默认', code: 10 }, { name: '销量从高到低', code: 21 }, { name: '评分从高到低', code: 60 }, { name: '价格从高到低', code: 31 }, { name: '价格从低到高', code: 30 }
            // , { text: '评分高到低', value: 4 }
          ]
        }
      ]
    }
  },
  components: { uniRate, uniLoadMore, search },
  onReady() {



    // uni.showTabBar()
  },
  onLoad(event) {
    this.form.cityCode = event.cityCode || ''
    this.init()
  },
  onPullDownRefresh() {
    this.list = []
    this.page.currentPage = 1
    this.queryData('refresh')
  },
  onReachBottom() {
    if (this.list.length < this.count) {
      this.queryData()
    }
  },
  methods: {
    async init() {
      let list = await getListByCode('', '/weChat/foodBody/querylabelCode', true)
      // this.labelList = Array.isArray(list) ? [{ name: '全部', code: '' }].concat(list) : []
      this.menu[0].detailList = list
      // this.getLocation()
      this.queryData('refresh')
    },
    getLocation() {
      let code = '330700000000'
      let data = getListByCode(code)
      let _this = this
      data.then(result => {
        _this.actions = result.map(t => {
          return {
            name: t.name,
            code: t.code
          }
        })
        _this.actions.unshift({
          name: '金华市',
          code: ''
        })
        _this.city = _this.actions[0]
      })
    },
    handleClick(item) {
      uni.navigateTo({
        url: `/pages/cate/detail?id=${item.id}`
      })
    },
    nameInput(event) {
      this.form.bodyName = event.target.value || ''
    },
    querySearchData() {
      this.page.currentPage = 1
      this.list = []
      this.queryData()
    },
    confirm(item) {
      // console.log(item)
      if (item.index === 0) {
        this.form.labelCode = item.code || ''
      } else if (item.index === 1) {
        this.form.orderByIndex = item.code || ''
      }
      this.querySearchData()
    },
    changePicker(item) {
      // console.log('changePicker',item)
      let label = item.label ? item.label : '请选择'
      this.city.name = label
      this.genAreaCode(item.cityCode)
      this.querySearchData()
    },
    genAreaCode(cityCode) {
      // console.log('genCode',cityCode)
      if (cityCode.area) {
        this.form.districtCode = cityCode.area + '000000'
        this.city.code = this.form.districtCode
      } else if (cityCode.city) {
        this.form.cityCode = cityCode.city + '00000000'
        this.city.code = this.form.cityCode
      } else if (cityCode.province) {
        this.form.provinceCode = cityCode.province + '0000000000'
        this.city.code = this.form.provinceCode
      } else {
        this.form.provinceCode = ''
        this.form.cityCode = ''
        this.form.districtCode = ''
        this.city.code = ''
      }
    },
    scroll(e) {
      let _top = e.detail.scrollTop
      if (_top > 13) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
    reset(index) {
      // console.log(index)
      if (index === 0) {
        this.form.labelCode = ''
      } else if (index === 1) {
        this.form.orderByIndex = 10
      }
      this.querySearchData()
    },
    queryData(status) {
      let _this = this
      _this.page.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/foodBody/queryPage',
        data: {
          ...this.form,
          ...this.page,
          status: 1
        }
      }).then(res => {
        _this.list.push.apply(_this.list, this.renderData(res.data))
        _this.page.loading = false
        _this.page.count = res.count
        _this.count = res.count
        if (_this.list.length >= _this.count) {
          _this.end = true
        }
        _this.page.currentPage += 1
        if (status === 'refresh') {
          uni.stopPullDownRefresh();
        }
        _this.page.loading = false
      })
    },
    renderData(data) {
      return data.map(t => {
        let setMeal = []
        let cashCoupon = []
        if (t.productName && t.productName.length > 0) {
          t.productName.map((t) => {
            if (t.foodType === 2) {
              setMeal.push(t)
            } else if (t.foodType === 1) {
              cashCoupon.push(t)
            }
          })
        }
        return {
          ...t,
          setMeal,
          cashCoupon,
          rate: t.grade ? parseFloat(t.grade) : 5,
          tagList: t.list ? t.list : []
          // itemType: t.labelName ? (t.labelName.split(',')).shift() : '' // 暂时只取一个标签 - 2.0升3.0的不要标签了
        }
      })
    },
    getHeaderImg() {
      let _this = this
      this.$ajax({
        method: 'POST',
        url: '/weChat/sowing/querySowingProduct',
        data: {
          areaNumbers: 'JH-CTLB-001'
        },
        success: function (result) {
          let adv = result.data['JH-CTLB-001'] || ''
          _this.header = adv[0] ? _this.$getImg(adv[0].imageUrl) : _this.header
          _this.headerJumpUrl = adv[0] ? adv[0].jumpUrl : _this.headerJumpUrl
        }
      })
    }
  }
}
